import React from 'react';
import '../../../../css/common/chat/ChatEmptyState.css';

const ChatEmptyState = ({ ariaLabel = 'チャットを選択してください' }) => (
  <div className="chat-empty-state-shell" aria-label={ariaLabel}>
    <div className="chat-empty-state">
      <i className="fa-regular fa-comments chat-empty-state__icon" aria-hidden="true"></i>
      <p className="chat-empty-state__text">選択してください</p>
    </div>
  </div>
);

export default ChatEmptyState;
